import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICountry, IDepartament, IMunicipality } from '../models/ubication';
import { UbicationEndpoint } from '../endpoints/ubication';

/**
 *
 */
@Injectable({
  providedIn: 'root',
})
export class Ubication {
  private readonly http = inject(HttpClient);

  /**
   * @ignore
   * @param http Parametro que tiene las funcionalidades de HttpClient.
   */
  constructor() {}

  /**
   * obtener lista de municipios
   * @param {number} state codigo de provincia
   * @returns observable de tipo array de municipios
   */
  getMunicipalities(state: number): Observable<Array<IMunicipality>> {
    return this.http.get<Array<IMunicipality>>(`${UbicationEndpoint.municipalities}${state}/`);
  }

  /**
   * Función que obtiene la lista de municipios de un departamento específico.
   * @param {number} state Codigo del departamento.
   * @returns observable de tipo array de municipios
   */
  getNewMunicipalities(state: number): Observable<Array<IMunicipality>> {
    return this.http.get<Array<IMunicipality>>(`${UbicationEndpoint.municipios_new}${state}/`);
  }

  /**
   * Función que obtiene la lista de paises(ISO 3166-2)
   * @returns Observable con la lista de paises
   */
  getCountries(): Observable<Array<ICountry>> {
    return this.http.get<Array<ICountry>>(UbicationEndpoint.country);
  }

  /**
   * Función que obtiene y retorna la lista de despartamentos para un país en especifico
   * @param {number} codigo del país
   * @returns observable con los departamentos
   */
  getDepartments(country: number): Observable<Array<IDepartament>> {
    return this.http.get<Array<IDepartament>>(`${UbicationEndpoint.departaments}${country}/`);
  }

  /**
   * Función que obtiene todos los departamentos y retorna los retorna.
   * @returns observable con los departamentos
   */
  getDepartmentsAll(): Observable<Array<IDepartament>> {
    return this.http.get<Array<IDepartament>>(`${UbicationEndpoint.departaments_all}`);
  }

  /**
   * cities list
   * @param {number} country province code
   * @returns observable of departaments
   */
  getProvinces(country: number): Observable<Array<IDepartament>> {
    return this.http.get<Array<IDepartament>>(`${UbicationEndpoint.provinces}${country}/`);
  }
}
